<template>
    <section>
        <div class="row justify-content-center">
            <div class="col col-lg-10 px-5">
		<b-modal
                    v-model="popup"
                    size="lg"
                    modal-class="border-0"
                    header-class="background-primary"
                    footer-class="justify-content-center"
                    v-bind:centered="true"
                    v-bind:hide-footer="true"
                >
                    <template slot="modal-header">
                        <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0"
                        >PENGUMUMAN
                        </h4>
                    </template>
                    <div class="container px-5 py-2">
                    <!-- <div class="d-block text-center"> -->
                        <a href="#"
                        ><img
                            src="/static/images/page/about/Poster Ketentuan Forum.png"
                            alt="attention"
                            border="0"
                            width="70%"
                        /></a> 
                        <button
                            v-on:click="popup = false"
                            class="btn btn-sm btn-outline-danger px-5 mt-2 mb-3 d-block mx-auto"
                        >Tutup
                        </button>
                    </div>
                </b-modal>
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mt-5 mb-0 py-0">
                        <li class="breadcrumb-item h3 font-weight-bold active mb-0 text-uppercase" aria-current="page">
                            Forum
                        </li>
                    </ul>
                    <ul class="breadcrumb forum py-0">
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'index' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium active" aria-current="page">
                            Forum
                        </li>
                    </ul>
                </nav>
                <div class="row">
                    <div class="col">
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0 text-uppercase">
                                            Kelas
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body py-0">
                                <div class="row">
                                    <div class="col-12 col-sm-6 border-bottom py-3" v-for="grade in grades">
                                        <router-link v-bind:to="{ name: 'forum/subject', params: {id: grade.id} }" class="font-weight-bold h4 mb-1">{{ grade.name }}</router-link>
                                        <div class="row text-muted">
                                            <div class="col-auto">
                                                Jumlah Pelajaran: {{ grade.totalSubjects }}
                                            </div>
                                            <div class="col-auto">
                                                Jumlah Thread: {{ grade.totalThreads }}
                                            </div>
                                            <div class="col-auto">
                                                Solved Thread: {{ grade.solvedThreads }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "ForumIndex",
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                grades: [],
		popup: true,
            };
        },
        created() {

            if (this.profile.isStudent) {
                this.$router.replace({name: 'forum/subject', params: {id: this.profile.student.gradeID}});
            } else {
                this.axios.get(process.env.API_URL + '/grade').then(response => {
                    this.grades = response.data.data;

                    document.title = 'Forum - ' + process.env.APP_NAME;

                });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/Index.vue